/* POTO VÉTO — Liquid Glass : interactions */
(function () {
  // Apparition douce au scroll
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.pv-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Flèches des carrousels
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pv-rail-dir]');
    if (!btn) return;
    var rail = btn.closest('[data-pv-rail-wrap]').querySelector('[data-pv-rail]');
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 18 : 280;
    rail.scrollBy({ left: step * Number(btn.dataset.pvRailDir), behavior: 'smooth' });
  });

  // Fiche produit : galerie + onglets Photos / Sommaire / Intérieur
  function initProduct(root) {
    (root || document).querySelectorAll('[data-pv-product]').forEach(function (prod) {
      if (prod.dataset.ready) return;
      prod.dataset.ready = '1';

      var main = prod.querySelector('[data-pv-main-img]');
      prod.querySelectorAll('[data-pv-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          prod.querySelectorAll('[data-pv-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main) {
            main.classList.add('is-fading');
            setTimeout(function () {
              main.src = t.dataset.src;
              main.srcset = t.dataset.srcset || '';
              main.classList.remove('is-fading');
            }, 160);
          }
        });
      });

      // Onglets de l'aperçu
      var tabs = prod.querySelectorAll('[data-pv-tab]');
      var panels = prod.querySelectorAll('[data-pv-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.pvTab;
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) {
            var on = p.dataset.pvPanel === key;
            p.hidden = !on;
            // Le PDF n'est chargé qu'à la première ouverture de l'onglet
            var frame = p.querySelector('iframe[data-src]');
            if (on && frame && !frame.src) {
              // Navigateurs sans lecteur PDF intégré (Chrome Android…) : bouton d'ouverture à la place
              if (navigator.pdfViewerEnabled === false) {
                p.classList.add('pv-pdf-fallback');
              } else {
                frame.src = frame.dataset.src;
              }
            }
          });
          var ind = prod.querySelector('.pv-tabs__indicator');
          if (ind) { ind.style.width = tab.offsetWidth + 'px'; ind.style.transform = 'translateX(' + tab.offsetLeft + 'px)'; }
        });
      });
      var first = prod.querySelector('[data-pv-tab][aria-selected="true"]');
      if (first) {
        var ind = prod.querySelector('.pv-tabs__indicator');
        requestAnimationFrame(function () {
          if (ind) { ind.style.width = first.offsetWidth + 'px'; ind.style.transform = 'translateX(' + first.offsetLeft + 'px)'; }
        });
      }

      // Variantes (carte cadeau, etc.)
      var idInput = prod.querySelector('[data-pv-variant-id]');
      var priceEl = prod.querySelector('[data-pv-price]');
      var addBtn = prod.querySelector('[data-pv-add]');
      prod.querySelectorAll('[data-pv-variant]').forEach(function (v) {
        v.addEventListener('click', function () {
          prod.querySelectorAll('[data-pv-variant]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          v.setAttribute('aria-pressed', 'true');
          if (idInput) idInput.value = v.dataset.pvVariant;
          if (priceEl) priceEl.innerHTML = v.dataset.price;
          if (addBtn) {
            var ok = v.dataset.available === 'true';
            addBtn.disabled = !ok;
            addBtn.querySelector('span').textContent = ok ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.dataset.pvVariant);
          window.history.replaceState({}, '', url.toString());
        });
      });

      // Quantité
      var qty = prod.querySelector('[data-pv-qty]');
      prod.querySelectorAll('[data-pv-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.pvQtyStep));
          qty.value = n;
        });
      });
    });
  }

  // Barre d'annonce : rotation des messages (visible sur mobile)
  function initAnn(root) {
    (root || document).querySelectorAll('[data-pv-ann]').forEach(function (ann) {
      if (ann.dataset.ready) return;
      ann.dataset.ready = '1';
      var items = ann.querySelectorAll('.pv-ann__item');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, Number(ann.dataset.interval) || 4000);
    });
  }

  // Carrousels : retirer le fondu quand on arrive au bout
  function initRails(root) {
    (root || document).querySelectorAll('[data-pv-rail]').forEach(function (rail) {
      function upd() { rail.classList.toggle('is-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4); }
      rail.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  function boot(root) { initReveal(root); initProduct(root); initAnn(root); initRails(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Éditeur de thème : réinitialiser quand une section est rechargée
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
